import { IConsumption } from "../core/contracts/IConsumption";
import addTime, { getFixedTimezoneDate, isDateValid } from "../helpers/datetime";
import BaseService from "./BaseService";
// import { makeConsumptionReading, mockRequest } from "./MockService";
import get from "lodash/get";
import { isAfter } from "date-fns";

export type InstallationConsumptionServiceFetchParams = {
  installation_id: string;
  startDate?: Date;
  endDate?: Date;
};

type InstallationConsumptionFetchParams = {
  installation_id: string;
  start_date?: string;
  end_date?: string;
};

const mapRequest = (param: InstallationConsumptionServiceFetchParams) => {
  const { installation_id, startDate, endDate } = param;
  const minDate = addTime(new Date(), -6, "mo");
  return {
    installation_id: installation_id,
    start_date: isDateValid(startDate)
      ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        isAfter(minDate, startDate!)
        ? getFixedTimezoneDate(minDate).toISOString()
        : startDate && getFixedTimezoneDate(startDate)?.toISOString()
      : getFixedTimezoneDate(addTime(new Date(), -1, "week")).toISOString(),
    end_date: getFixedTimezoneDate(endDate || new Date()).toISOString(),
  };
};

export default class InstallationConsumptionService extends BaseService {
  async fetch(params: InstallationConsumptionServiceFetchParams): Promise<IConsumption> {
    try {
      const requestParams = [mapRequest(params)];
      const APIResponse = await new BaseService().post<
        { installations: IConsumption[] },
        InstallationConsumptionFetchParams[]
      >(`/consumption`, requestParams);

      return get(APIResponse, "installations[0]", []);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationConsumptionService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetchMultiple(
    params: InstallationConsumptionServiceFetchParams[]
  ): Promise<IConsumption[]> {
    try {
      const requestParams: InstallationConsumptionFetchParams[] = params.map((param) =>
        mapRequest(param)
      );

      const APIResponse = await new BaseService().post<
        { installations: IConsumption[] },
        InstallationConsumptionFetchParams[]
      >(`/consumption`, requestParams);

      return get(APIResponse, "installations", []);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("InstallationConsumptionService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }
}
